// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__30K7J","form":"styles_form__on-Gk"};